import React, { useState, useEffect } from 'react';
import { Button, Grid, InputLabel, TextField, Typography } from '@mui/material';
import NavigationDrawer from '../../../../components/navigationDrawer';
import { primaryColor, secondaryColor } from '../../../../constants/colors';
import useStyles from '../../../../globalStyles';
import { updateAdminProfile,changePasswordAdmin } from '../../../../services/authentication';
import SnackbarAlert from '../../../../components/snackbar/SnackbarAlert';
import {
  adminChangePass,
  getAdminMessages,
  updateAdminMessages,
} from './../../../../services/adminSettings/index';
import Loader from '../../../../components/loader';
import ImageUploader from './../../../../components/imageUploader/index';

const AdminSettings = () => {
  const classes = useStyles();
  const userData = JSON.parse(localStorage.getItem('user'));
  const [inputValue, setInputValue] = useState({
    name: userData.name,
    email: '',
    currentPassword: '',
    newPassword: '',
  });
  const [settingsVal, setSettingsVal] = useState({
    rejectedText: '',
    acceptedText: '',
    deliveredText: '',
    onWayText: '',
    newMsgText: '',
    pickupMessage: '',
  });
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: '',
    message: '',
  });
  const [image, setImage] = useState(userData?.image);
  const [isLoading, setIsLoading] = useState(false);
  const [msgObjId, setMsgObjId] = useState(null);

  useEffect(() => {
    // setIsLoading(true);
    // getAdminMessages()
    //   .then((res) => {
    //     setIsLoading(false);
    //     setMsgObjId(res.data.data._id);
    //     setSettingsVal({
    //       rejectedText: res.data.data.RejectedMessage,
    //       acceptedText: res.data.data.AcceptedMessage,
    //       deliveredText: res.data.data.DeliveryMessage,
    //       onWayText: res.data.data.onWayMessage,
    //       newMsgText: res.data.data.chatMessage,
    //       pickupMessage: res.data.data.pickupMessage,
    //     });
    //   })
    //   .catch((err) => {
    //     setIsLoading(false);
    //     console.log(err, "asdsadsad");
    //   });
  }, []);

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };
  const handleChangeValue = (e) => {
    setInputValue({ ...inputValue, [e.target.name]: e.target.value });
  };
  const handleChangeSettings = (e) => {
    setSettingsVal({ ...settingsVal, [e.target.name]: e.target.value });
  };

  const handleUpdateUsername = () => {
    if (inputValue.name == '') {
      handleSnackbarVal(true, 'error', 'Name cannot be empty');
    } else {
      const payload = { name: inputValue.name };
      setIsLoading(true);
      updateAdminProfile(userData._id, payload)
        .then((res) => {
          let newObj = {
            ...userData,
            name: res.data.data.name,
            image: image,
          };
          setIsLoading(false);
          localStorage.setItem('user', JSON.stringify(newObj));
          handleSnackbarVal(true, 'success', res.data.message);
        })
        .catch((error) => {
          console.log(error, 'Error');
          setIsLoading(false);
          handleSnackbarVal(true, 'error', error?.response?.data?.message);
        });
    }
  };
  const handleUpdateMessages = () => {
    if (settingsVal.rejectedText == '') {
      handleSnackbarVal(true, 'error', 'Rejected Text cannot be empty');
    }
    if (settingsVal.acceptedText == '') {
      handleSnackbarVal(true, 'error', 'Accepted Text cannot be empty');
    }
    if (settingsVal.deliveredText == '') {
      handleSnackbarVal(true, 'error', 'Delivered Text cannot be empty');
    }
    if (settingsVal.onWayText == '') {
      handleSnackbarVal(true, 'error', 'On Way Text cannot be empty');
    }
    if (settingsVal.newMsgText == '') {
      handleSnackbarVal(true, 'error', 'New Message Text cannot be empty');
    } else {
      const payload = {
        AcceptedMessage: settingsVal.acceptedText,
        DeliveryMessage: settingsVal.deliveredText,
        RejectedMessage: settingsVal.rejectedText,
        chatMessage: settingsVal.chatMessage,
        onWayMessage: settingsVal.onWayText,
        pickupMessage: settingsVal.pickupMessage,
      };
      return;
      setIsLoading(true);
      updateAdminMessages(msgObjId, payload)
        .then((res) => {
          setIsLoading(false);
          handleSnackbarVal(true, 'success', 'Messages Updated Successfully');
        })
        .catch((error) => {
          console.log(error, 'Error');
          setIsLoading(false);
          handleSnackbarVal(true, 'error', error?.response?.data?.message);
        });
    }
  };

  const handleUpdatePass = () => {
    if (inputValue.currentPassword == '' || inputValue.newPassword == '') {
      handleSnackbarVal(true, 'error', 'Password fields cannot be empty');
    } else {
      const payload = {
        email: userData?.email,
        password: inputValue.currentPassword,
        newPassword: inputValue.newPassword,
      };
      setIsLoading(true);
      changePasswordAdmin(payload)
        .then((res) => {
          if (res?.data?.status == "ok") {
            setIsLoading(false);
            handleSnackbarVal(true, 'success', res.data.message);
            setInputValue({
              currentPassword:"",
              newPassword:"",
            })
          }else{
            setIsLoading(false);
            handleSnackbarVal(true, 'error', res.data.message);
            setInputValue({
              currentPassword:"",
              newPassword:"",
            })
          }
        })
        .catch((error) => {
          console.log(error, 'Error');
          setIsLoading(false);
          handleSnackbarVal(true, 'error', error?.response?.data?.message);
        });
    }
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, '', '');
  };

  return (
    <NavigationDrawer>
      <Loader isloading={isLoading} />
      <SnackbarAlert
        snackbarProps={snackbarProps}
        handleCloseSnackbar={handleCloseSnackbar}
      />
      <div
        style={{
          boxShadow: '0 0.2rem 1rem rgb(0 0 0 / 12%)',
          padding: '20px',
        }}
      >
        <Typography style={{ fontSize: '22px', fontWeight: '600' }}>
          Edit Profile
        </Typography>

        <Grid container marginTop={3} spacing={2}>
          <Grid item xs={12}>
            <InputLabel style={{ margin: '5px 0', fontWeight: '600' }}>
              Change User Name
            </InputLabel>
            <TextField
              variant='outlined'
              placeholder='User Name'
              name='name'
              autoComplete='name'
              className={classes.globalInput}
              onChange={handleChangeValue}
              value={inputValue.name}
              style={{ width: '25%' }}
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <div style={{ width: '25%', textAlign: 'right' }}>
              <Button
                variant='contained'
                size='small'
                onClick={handleUpdateUsername}
                disableRipple
                sx={{
                  width: '42%',
                  backgroundColor: primaryColor,
                  textTransform: 'none',
                  marginTop: '10px',
                  boxShadow: 'none',
                  '&:hover': {
                    backgroundColor: secondaryColor,
                  },
                }}
              >
                <Typography style={{ fontSize: '12px' }}>
                  Update Profile
                </Typography>
              </Button>
            </div>
          </Grid>
        </Grid>

        <Grid container marginTop={3} spacing={2}>
          <Grid item xs={12} sm={12}>
            <InputLabel style={{ margin: '5px 0', fontWeight: '600' }}>
              Change Password
            </InputLabel>
            <TextField
              variant='outlined'
              placeholder='Email'
              disabled
              name='email'
              autoComplete='email'
              className={classes.globalInput}
              onChange={handleChangeValue}
              value={userData?.email}
              style={{ width: '25%' }}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              variant='outlined'
              placeholder='Current Password'
              name='currentPassword'
              type='password'
              className={classes.globalInput}
              onChange={handleChangeValue}
              value={inputValue.currentPassword}
              style={{ width: '25%' }}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              variant='outlined'
              placeholder='New Password'
              name='newPassword'
              type='password'
              className={classes.globalInput}
              onChange={handleChangeValue}
              value={inputValue.newPassword}
              style={{ width: '25%' }}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <div style={{ width: '25%', textAlign: 'right' }}>
              <Button
                variant='contained'
                size='small'
                onClick={handleUpdatePass}
                disableRipple
                sx={{
                  width: '42%',
                  backgroundColor: primaryColor,
                  textTransform: 'none',
                  marginTop: '10px',
                  boxShadow: 'none',
                  '&:hover': {
                    backgroundColor: secondaryColor,
                  },
                }}
              >
                <Typography style={{ fontSize: '12px' }}>
                  Update Password
                </Typography>
              </Button>
            </div>
          </Grid>
        </Grid>
        <div style={{ width: '25%', textAlign: 'right' }}></div>
      </div>
    </NavigationDrawer>
  );
};

export default AdminSettings;
